<template>
  <div>
    <app-heading :text="'NBN Bulk Upload'" :heading="'main'"></app-heading>

    <v-row class="mb-4">
      <v-col cols="12" class="pt-0 pb-0">
        <v-btn v-if="canBulkUpload"
               class="primary mt-6"
               @click="showBulkUpload = true">
          <v-icon left>mdi-upload</v-icon>
          Upload CSV
        </v-btn>
      </v-col>
    </v-row>

    <nbn-bulk-upload :showDialog="showBulkUpload"
                     @closeBulkUpload="showBulkUpload = false"
                     @bulkUploadError="handleError"></nbn-bulk-upload>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import NbnBulkUpload from "@/components/orderQualification/nbn-bulk-upload";

  export default {
    name: "NbnBulkUploadView",
    components: { NbnBulkUpload },
    data: () => ({
      showBulkUpload: false
    }),
    computed: {
      ...mapGetters("auth", ["rolesResolved", "isBulkUploadAdmin"]),
      canBulkUpload() {
        return this.rolesResolved && this.isBulkUploadAdmin;
      }
    },
    created() {
      this.redirectIfNotBulkUploadAdmin();
    },
    watch: {
      rolesResolved() {
        this.redirectIfNotBulkUploadAdmin();
      },
      isBulkUploadAdmin() {
        this.redirectIfNotBulkUploadAdmin();
      },
      canBulkUpload(allowed) {
        if (!allowed) this.showBulkUpload = false;
      }
    },
    methods: {
      redirectIfNotBulkUploadAdmin() {
        if (this.rolesResolved && !this.isBulkUploadAdmin) {
          this.$router.replace({ name: "NBN Direct" }).catch(() => {});
        }
      },
      handleError(error) {
        this.setHttpResponse({
          text: `Bulk upload error: ${error?.response?.data || error?.message || error}`,
          color: "error"
        });
      }
    }
  };
</script>
